<template>
	<div class="">
		<el-breadcrumb separator-class="el-icon-arrow-right" class="m-b-20">
			<el-breadcrumb-item class="color_A6A6A6"><span class="com_pointer" @click="$router.push('/pass')">知识宝典</span></el-breadcrumb-item>
			<el-breadcrumb-item>购买套餐</el-breadcrumb-item>
		</el-breadcrumb>
		<p class="color_666 m-b-20">购买任意套餐后，在有效期内可使用全站所有收费试卷；免费试卷无需购买即可答题。</p>

		<el-row :gutter="20" v-loading="loading">
			<el-col :xs="24" :sm="12" :md="12" v-for="(item, index) in packageList" :key="index" class="m-b-20">
				<el-card shadow="hover" class="package-card" :class="{ 'package-active': selectedId === item.id }"
					@click.native="selectedId = item.id">
					<div class="text_c">
						<div class="font_weight font_s18 m-b-10">{{ item.name }}</div>
						<div class="price-box">
							<span class="font_s14">¥</span>
							<span class="font_s40 font_weight" style="color: #E6A23C;">{{ item.price }}</span>
						</div>
						<div class="color_666 font_s14 m-t-10">有效期：{{ item.duration_days }}天</div>
						<div class="color_999 font_s12 m-t-5" v-if="item.remark">{{ item.remark }}</div>
						<div class="m-t-15">
							<el-tag v-if="item.is_active_for_user" type="success" size="small">已购买（有效期至{{ item.expire_date }}）</el-tag>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>

		<div v-if="!loading && packageList.length > 0" class="text_c m-t-20">
			<el-button type="primary" size="large" :disabled="!selectedId || submitting"
				:loading="submitting" @click="buyPackage"
				style="background-color: #163F88; border-color: #163F88; width: 300px;">
				立即购买
			</el-button>
		</div>

		<div v-if="!loading && packageList.length === 0" class="text_c p-30">
			<i class="el-icon-shopping-bag-2" style="font-size: 60px; color: #ccc;"></i>
			<p class="color_999 m-t-10">暂无可购买的套餐</p>
		</div>

		<el-dialog title="微信扫码支付" :visible.sync="payDialogVisible" width="360px" center>
			<div class="text_c">
				<img v-if="payQrcode" :src="payQrcode" alt="微信支付二维码" class="pay-qrcode">
				<div v-else class="pay-code-url">{{ payCodeUrl }}</div>
				<p class="color_666 m-t-15">请使用微信扫码完成支付</p>
				<p class="color_999 font_s12 m-t-5">支付成功后，系统会自动开通知识宝典全部收费试卷权限。</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="payDialogVisible = false">稍后支付</el-button>
				<el-button type="primary" @click="goOrders" style="background-color: #163F88; border-color: #163F88;">我已支付</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: "PassPackages",
	data() {
		return {
			loading: false,
			submitting: false,
			resumingWechatPay: false,
			packageList: [],
			selectedId: '',
			payDialogVisible: false,
			payQrcode: '',
			payCodeUrl: '',
		};
	},
	activated() {
		this.initPage();
	},
	mounted() {
		this.initPage();
		this.resumePendingWechatPay();
	},
	methods: {
		initPage() {
			if (!localStorage.getItem('u_token')) {
				this.$message.info('请先登录！');
				this.$router.push('/login');
				return;
			}
			this.getPackageList();
		},
		getPackageList() {
			if (this.loading) return;
			this.loading = true;
			this.$api.authPass.getPackageList({}).then((res) => {
				if (res.code == 1) {
					this.packageList = res.data || [];
					if (!this.selectedId && this.packageList.length > 0) {
						this.selectedId = this.packageList[0].id;
					}
				} else {
					this.packageList = [];
				}
				if (this.packageList.length === 0) {
					this.loadPublicPackageList();
				}
			}).catch(() => {}).finally(() => {
				this.loading = false;
			});
		},
		loadPublicPackageList() {
			this.$api.pass.getPackageList({}).then((res) => {
				if (res.code == 1) {
					this.packageList = res.data || [];
					if (!this.selectedId && this.packageList.length > 0) {
						this.selectedId = this.packageList[0].id;
					}
				}
			}).catch(() => {});
		},
		buyPackage() {
			if (!this.selectedId) return;
			const pkg = this.packageList.find(p => p.id === this.selectedId);
			if (pkg && pkg.is_active_for_user) {
				this.$message.info('您已购买该套餐且在有效期内');
				return;
			}
			this.submitting = true;
			this.$api.authPass.createOrder({ package_id: this.selectedId }).then((res) => {
				if (res.code == 1 && res.data) {
					return this.requestWechatPay(res.data.order_no);
				} else {
					this.$message.error(res.info || '创建订单失败');
				}
			}).catch(() => {
				this.$message.error('创建订单失败，请重试');
			}).finally(() => {
				this.submitting = false;
			});
		},
		requestWechatPay(orderNo) {
			if (!orderNo) {
				this.$message.error('订单号为空，无法发起支付');
				return;
			}
			const isWechatBrowser = /MicroMessenger/i.test(window.navigator.userAgent || '');
			if (isWechatBrowser) sessionStorage.setItem('pass_pending_pay_order_no', orderNo);
			return this.getWechatPayOpenid(isWechatBrowser).then((openid) => this.$api.authPass.wxpay({ order_no: orderNo, openid })).then((res) => {
				if (res.code != 1 || !res.data) {
					this.$message.error(res.info || '发起微信支付失败');
					return;
				}
				if (res.data.pay_type === 'JSAPI') {
					sessionStorage.removeItem('pass_pending_pay_order_no');
					this.callWechatJsapi(res.data.params);
					return;
				}
				sessionStorage.removeItem('pass_pending_pay_order_no');
				this.payQrcode = res.data.qrcode || '';
				this.payCodeUrl = res.data.code_url || '';
				this.payDialogVisible = true;
			}).catch((error) => {
				if (error && error.message === 'wechat oauth redirecting') return;
				this.$message.error('发起微信支付失败，请检查后台微信支付配置');
			});
		},
		resumePendingWechatPay() {
			const isWechatBrowser = /MicroMessenger/i.test(window.navigator.userAgent || '');
			const pendingOrderNo = sessionStorage.getItem('pass_pending_pay_order_no') || '';
			if (!isWechatBrowser || !pendingOrderNo || this.resumingWechatPay) return;
			this.resumingWechatPay = true;
			this.$message.info('正在继续微信支付，请稍候...');
			this.requestWechatPay(pendingOrderNo).finally(() => {
				this.resumingWechatPay = false;
			});
		},
		getWechatPayOpenid(isWechatBrowser) {
			if (!isWechatBrowser) return Promise.resolve('');
			const cachedOpenid = window.WeChatOpenid || localStorage.getItem('wechat_openid') || '';
			if (cachedOpenid) return Promise.resolve(cachedOpenid);
			return new Promise((resolve, reject) => {
				const oldScript = document.getElementById('wechat-pay-oauth-script');
				if (oldScript) oldScript.parentNode.removeChild(oldScript);
				const script = document.createElement('script');
				const source = encodeURIComponent(window.location.href);
				script.id = 'wechat-pay-oauth-script';
				script.referrerPolicy = 'unsafe-url';
				script.src = `${this.$api.baseUrl}/api/wechat/oauth?mode=0&source=${source}&_=${Date.now()}`;
				script.onload = () => {
					setTimeout(() => {
						const openid = window.WeChatOpenid || '';
						if (openid) {
							localStorage.setItem('wechat_openid', openid);
							resolve(openid);
							return;
						}
						this.$message.info('正在跳转微信授权，授权完成后会自动继续支付');
						reject(new Error('wechat oauth redirecting'));
					}, 300);
				};
				script.onerror = () => reject(new Error('wechat oauth failed'));
				document.head.appendChild(script);
			});
		},
		callWechatJsapi(params) {
			if (!params) {
				this.$message.error('微信支付参数为空');
				return;
			}
			const invokePay = () => {
				window.WeixinJSBridge.invoke('getBrandWCPayRequest', params, (res) => {
					if (res.err_msg === 'get_brand_wcpay_request:ok') {
						this.$message.success('支付成功');
						this.goOrders();
					} else {
						this.$message.info('支付未完成');
					}
				});
			};
			if (typeof window.WeixinJSBridge === 'undefined') {
				document.addEventListener('WeixinJSBridgeReady', invokePay, false);
			} else {
				invokePay();
			}
		},
		goOrders() {
			this.payDialogVisible = false;
			this.$router.push({ path: '/center', query: { tab: 'passOrders' } });
		}
	}
};
</script>
<style scoped>
.package-card {
	border-radius: 12px;
	cursor: pointer;
	transition: all 0.3s;
	border: 2px solid transparent;
}
.package-card:hover {
	transform: translateY(-4px);
	box-shadow: 0 4px 20px rgba(22, 63, 136, 0.15);
}
.package-active {
	border-color: #163F88;
	box-shadow: 0 4px 20px rgba(22, 63, 136, 0.2);
}
.price-box {
	padding: 10px 0;
}
.pay-qrcode {
	width: 220px;
	height: 220px;
	object-fit: contain;
}
.pay-code-url {
	word-break: break-all;
	color: #666;
	font-size: 12px;
	line-height: 1.6;
	padding: 15px;
	background: #f7f7f7;
	border-radius: 6px;
}
@media screen and (max-width: 768px) {
	.package-card {
		margin-bottom: 10px;
	}
}
</style>
